/* RESPONSIBLE TEAM: team-proactive-support */
import { inject as service } from '@ember/service';
import PerformanceReportBase from 'embercom/routes/apps/app/reports/base/performance-report';

export default PerformanceReportBase.extend({
  customReportsService: service(),

  beforeModel() {
    this.customReportsService.routeToOverviewPage();
  },
});
